var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#2C9942"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.32452 15.4599C7.09919 15.3473 7.00786 15.0733 7.12052 14.848C7.23318 14.6226 7.50716 14.5313 7.7325 14.6439L10.9255 16.2404C11.1508 16.3531 11.2421 16.6271 11.1295 16.8524C11.0168 17.0778 10.7428 17.1691 10.5175 17.0564L7.32452 15.4599Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1127 6.20636C12.2411 6.14215 12.3923 6.14215 12.5207 6.20636L18.9067 9.39933C19.0612 9.4766 19.1588 9.63456 19.1588 9.80733V16.1933C19.1588 16.3661 19.0612 16.524 18.9067 16.6013L12.5207 19.7943C12.3923 19.8585 12.2411 19.8585 12.1127 19.7943L5.72676 16.6013C5.57222 16.524 5.47461 16.3661 5.47461 16.1933V9.80733C5.47461 9.63456 5.57222 9.4766 5.72676 9.39933L8.45407 8.03568L14.9519 11.5511V14.5968C14.9519 14.8487 15.1561 15.0529 15.408 15.0529C15.6599 15.0529 15.8641 14.8487 15.8641 14.5968L15.8642 11.2793C15.8642 11.1118 15.7724 10.9578 15.6251 10.8781L9.45044 7.5375L12.1127 6.20636ZM6.38689 10.5454L11.8606 13.2822V18.6482L6.38689 15.9114V10.5454Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.847fa315e9842aecc40aca7ea2bf8ee7.svg";
export { ForwardRef as ReactComponent };